const rupaMigration = {
  placeholder: "This is an UNAUTHENTICATED page",
  description: "Welcome to the Rupa Migration",
  button: "Start Migration",
  connect: "Connect",
  next: "Next",
  getHelp: "Get Help",
  continueToNextStep: "Continue to next step",
  supportInfo:
    "If you have any questions, please reach out to our Support team at <supportPhoneLink>{{supportPhone}}</supportPhoneLink> or <supportEmailLink>email {{supportEmail}}</supportEmailLink>",
  welcomeSubtitle: "A few things to know before you get started",
  card: {
    title: "Things to know about the move to Fullscript",
  },
  steps: {
    welcome: "Welcome",
    connectAccounts: "Connect Accounts",
    confirm: "Confirm",
    scheduleMove: "Schedule Move",
  },
  soloPractitioner: {
    welcomeTitle: "Moving from Rupa to Fullscript",
    items: {
      accountInfo: {
        title: "1. All of your data will move to Fullscript",
        details: {
          credentials: "Any credentials, your NPI, and physician authorization status",
          orderHistory: "Order history and orders in progress",
          patientList: "Your patient list",
          favorites: "Your favorites, blood panels, and bundles",
          snippets: "Your saved text snippets",
          preferredPhlebotomists: "Any preferred phlebotomists",
          notificationPreferences: "Notification preferences",
        },
      },
      newOrders: {
        title: "2. You'll place new lab orders on Fullscript",
        details: {
          allNewOrders: "The lab companies and tests you order will be available on Fullscript",
          inProgressOrders:
            "All orders placed on Rupa before the move need to be paid for and completed on Rupa",
          resultsView:
            "Once new results come in, they will be available to view on Fullscript and Rupa",
          viewOnly: "Your Rupa account will be available in a view-only state",
        },
      },
      patients: {
        title:
          "3. Your patients will complete any orders placed on Rupa before moving to Fullscript",
        details: {
          redirectedToFullscript:
            "We won't redirect your patients to Fullscript until all of their results are in",
          newOrders: "Any new orders will be sent to your patients from Fullscript",
          results:
            "Your patients' historical results will be available on Fullscript after they create their account",
          communicationWithPatients:
            "We won't email your patients about this change—it's up to you if and how you choose to communicate it with them",
        },
      },
      clinicStaff: {
        title: "4. If part of a clinic, all staff will move at the same time",
        details: {
          inviteEmail: "An invite email will be sent once their accounts have been moved",
          access: "After logging in, they will have access to all of their data from Fullscript",
          newOrders: "They will place all new orders on Fullscript",
        },
      },
    },
  },
  multiPractitioner: {
    welcomeTitle: "Scheduling your clinic's move to Fullscript",
    items: {
      accountInfo: {
        title: "1. Your entire clinic's data will move at the same time",
        details: {
          credentials: "All credentials, NPI, and physician authorization status",
          orderHistory: "Order history and orders in progress",
          patientList: "Patient profiles",
          favorites: "Your favorites, blood panels, and bundles",
          snippets: "Saved text snippets",
          preferredPhlebotomists: "Any preferred phlebotomists",
          notificationPreferences: "Notification preferences",
        },
      },
      newOrders: {
        title: "2. You'll place new lab orders on Fullscript",
        details: {
          allNewOrders: "The lab companies and tests you order will be available on Fullscript",
          inProgressOrders:
            "All orders placed on Rupa before the move need to be paid for and completed on Rupa",
          resultsView:
            "Once new results come in, they will be available to view on Fullscript and Rupa",
          viewOnly: "Your Rupa account will become view-only",
        },
      },
      patients: {
        title:
          "3. Your patients will complete any orders placed on Rupa before moving to Fullscript",
        details: {
          redirectedToFullscript:
            "We won't redirect your patients to Fullscript until all of their results are in",
          newOrders: "Any new orders will be sent to your patients from Fullscript",
          results:
            "Your patients' historical results will be available on Fullscript after they create their account",
          communicationWithPatients:
            "We won't email your patients about this change—it's up to you if and how you choose to communicate it with them",
        },
      },
      clinicStaff: {
        title: "4. All practitioners and staff will move at the same time",
        details: {
          inviteEmail: "An invite email will be sent once their accounts have been moved",
          access: "After logging in, they will have access to all of their data from Fullscript",
          newOrders: "They will place all new orders on Fullscript",
          untilTheMoveHappens: "Until the move happens, all orders should be placed on Rupa",
        },
      },
    },
  },
  emailLabel: "Email",
  passwordLabel: "Password",
  requiredIndicator: "*",
  createAccountButton: "Create account",
  patient: {
    joinHeading: "Join {{practitionerFullName}} on Fullscript",
    joinHeadingSendActivationEmail: "Join your practitioner on Fullscript",
    joinSubheading: "Your practitioner now uses Fullscript to manage labs. Create an account to:",
    benefit1: "View all your past lab results from Rupa",
    benefit2: "Purchase and manage new lab orders",
    benefit3: "Purchase high-quality supplements",
    passwordHeading: "Set a password for your new account",
  },
  termsText: "I agree to Fullscript's <1>Terms of Service</1> and <2>Privacy policy</2>.",
  clerk: {
    joinHeading: "Get excited, {{name}}!",
    joinHeadingExisting: "Welcome to {{-dispensaryName}}!",
    joinSubheading: "On Fullscript, you will be able to:",
    benefit1: "Order all of your labs and supplements from Fullscript",
    benefit2: "Get access to more blood lab options, including Quest!",
    benefit3: "Build and re-use plans for common treatments",
    benefit4: "Much more to come!",
    passwordHeading: "Create your new Fullscript account",
    alreadyHaveAccount: "Already have an account? <1>Sign in</1>",
  },
  practitioner: {
    joinHeading: "Get excited, {{name}}!",
    joinHeadingExisting: "Welcome to {{-dispensaryName}}!",
    joinSubheading: "On Fullscript, you will be able to:",
    benefit1: "Access top lab tests & supplements in one place",
    benefit2: "Offer a modern, streamlined testing experience",
    benefit3: "Turn results into actions with AI-powered insights",
    benefit4: "Get expert support by phone, chat, or email",
    passwordHeading: "Create your new Fullscript account",
    alreadyHaveAccount: "Already have an account? <1>Sign in</1>",
  },
  onboarding: {
    signDocuments: {
      success: "Documents signed successfully",
    },
  },
  OrderOnRupa: "Ordered on Rupa Health",
  rupaOrderBanner: {
    notPurchasedMessage:
      "The {{patientTerm}} will pay for and complete testing on Rupa. Once results are available, you'll be able to access them in both Rupa and Fullscript.",
    purchasedMessage:
      "The {{patientTerm}} will complete testing on Rupa. Once results are available, you'll be able to access them in both Rupa and Fullscript.",
  },
} as const;

export { rupaMigration };
